/**
 *
 * @collboard-modules-sdk
 */
export function isNumeric(n: any): boolean {
    return !isNaN(Number.parseFloat(n)) && Number.isFinite(n);
}
